export function fileNameFromUrl(url : string) {
    const segments = url.split('/');
    return decodeURIComponent(segments[segments.length - 1]);
}


// WEBPACK FOOTER //
// ./apps/common/services/fileurls.ts